<template>
    <div class="page-warpper" ref="info">
        <header-modular :url="web_emof_home"></header-modular>
        <div class="container">
            <div class="page-nav flex align-center justify-between margin-top-sm">
                <div class="flex align-center">
                    <div class="page-nav margin-right-xs">您现在的位置：<span v-if="navIndex.length > 1">{{ menus.find(f => {
                        return f.value === navIndex[0]
                    }).label }} > </span>{{ title }}
                    </div>
                </div>
                <div>欢迎{{ userInfo.user_type === 1 ? userInfo.company : userInfo.name }}登录会员中心</div>
            </div>
            <div class="page-container flex flex-sub">
                <menu-modular :navIndex="navIndex"></menu-modular>
                <div class="content-container">
                    <router-view @setIndex="getIndex(arguments)" class="content"></router-view>
                </div>
            </div>
        </div>
        <footer-modular></footer-modular>
        <!--    <el-button class="question" type="info" icon="el-icon-question" circle @click="dialogVisible = true"></el-button>-->
        <auto-opinion-dialog :dialogVisible="dialogVisible" @watchState="watchState"></auto-opinion-dialog>
        <router-link to="/version">
            <img v-if="isNew" class="version" src="../../assets/img/icon_version.png"/>
            <img v-else class="version" src="../../assets/img/icon_version.png"/>
        </router-link>
        <version-index-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                                     @watchState="watchState2"></version-index-detail-dialog>
        <help-windows v-if="false"></help-windows>
    </div>
</template>

<script>
import HeaderModular from "./components/HeaderModular.vue";
import FooterModular from "@/components/FooterSimpleModular";
import MenuModular from "./components/MenuModular.vue";
import AutoOpinionDialog from "@/components/AutoOpinionDialog";
import {memberMenus, web_emof_home} from '@/utils/const'
import {userInfo} from '@/api/member'
import config from '/package.json'
import VersionIndexDetailDialog from "@/components/VersionIndexDetailDialog";
import {getInfo} from "@/api/data";
import HelpWindows from "@/components/HelpWindows";

export default {
    name: "Home",
    components: {
        HelpWindows,
        AutoOpinionDialog,
        MenuModular,
        FooterModular, HeaderModular, VersionIndexDetailDialog
    },
    data() {
        return {
            menus: memberMenus,
            navIndex: [0],
            title: '',
            userInfo: '',
            web_emof_home: web_emof_home,
            dialogVisible: false,
            isNew: false,
            detailDialogVisible: false,
            cur_nid: 0,
        }
    },
    created() {
        let _version = window.localStorage.getItem('version') || '1.0.0'
        this.isNew = config.version > _version

        this.init()
        this.getUpInfo()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async getUpInfo() {
            let _data = await getInfo(this.user.type, this.user.link_id)
            if (_data.data.length === 1) {
                this.cur_nid = _data.data[0].id
                this.detailDialogVisible = true
            }
        },
        watchState2(val) {
            this.detailDialogVisible = false;
            if (val === 2) {
                this.$router.push('/version')
            }
        },
        async init() {
            let _data = await userInfo()
            if (_data.status === 200) {
                this.userInfo = _data.data
            }
        },
        getIndex(data) {
            this.navIndex = data[0]
            this.title = data[1]
            this.scrollTo()
        },
        toPage(url) {
            this.$router.replace(url)
        },
        scrollTo() {
            this.$nextTick(() => {
                this.$refs.info.scrollTo(0, 0);
            });
        },
        watchState() {
            this.dialogVisible = false
        }
    }

}
</script>

<style scoped lang="scss">
.page-warpper {
    height: 100vh;
    background: #ebeff5;
    overflow-y: scroll;

    .question {
        position: fixed;
        bottom: 80px;
        right: 80px;
        font-size: 28px;
    }

    .container {
        display: flex;
        flex-direction: column;
        width: 1200px;
        margin: 0 auto;

        .page-nav {
            font-size: 16px;
            color: #0a2240;
        }

        .page-container {
            margin: 15px 0;

            .content-container {
                display: flex;
                flex-direction: column;
                width: calc(100% - 180px);
                background-color: #0a2240;
                border-radius: 10px;
                padding: 20px;
                margin-left: 10px;

                .content {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }
            }
        }

    }

}
</style>
